import pl from "@locales/visit_templates/pl.json";
import en from "@locales/visit_templates/en.json";

export default { pl, en };
